import { apiClient } from '@/api/api'
import type { MenuRoot } from '@/types/menuItemTypes'

/**
 * Backend nodes are arbitrary-depth and use `children: null` for leaves, while
 * the menu type expects exactly three levels with arrays throughout. Depth
 * beyond the third level is dropped rather than flattened — the nav has no
 * place to render it.
 */
interface CategoryTreeNode {
  id: string | number
  label: string
  children?: CategoryTreeNode[] | null
}

interface CategoryTreeResponse {
  category_tree?: CategoryTreeNode[] | null
}

function toMenuRoot(nodes: CategoryTreeNode[]): MenuRoot {
  return nodes.map((root) => ({
    id: String(root.id),
    label: root.label,
    children: (root.children ?? []).map((child) => ({
      id: String(child.id),
      label: child.label,
      children: (child.children ?? []).map((leaf) => ({
        id: String(leaf.id),
        label: leaf.label
      }))
    }))
  }))
}

export const getCategoryTree = async (): Promise<MenuRoot> => {
  const response = await apiClient.get<CategoryTreeResponse>('/shopping-list/category-tree')
  return toMenuRoot(response.data?.category_tree ?? [])
}
